import { render, staticRenderFns } from "./order_receive_modal2.vue?vue&type=template&id=17945dc7&scoped=true"
import script from "./order_receive_modal2.vue?vue&type=script&lang=js"
export * from "./order_receive_modal2.vue?vue&type=script&lang=js"
import style0 from "./order_receive_modal2.vue?vue&type=style&index=0&id=17945dc7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17945dc7",
  null
  
)

export default component.exports